import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Novels from "../pages/novels/page";
import NovelDetail from "../pages/novelDetail/page";
import Gallery from "../pages/gallery/page";
import ShortStory from "../pages/story/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/xiaoshuo",
    element: <Novels />,
  },
  {
    path: "/xiaoshuo/:id",
    element: <NovelDetail />,
  },
  {
    path: "/tongrentu",
    element: <Gallery />,
  },
  {
    path: "/duanpian",
    element: <ShortStory />,
  },
  {
    path: "/duanpian/:id",
    element: <ShortStory />,
  },
  {
    path: "/guanyu",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;